/**
 * BRXEmbeddablesLoader
 *
 * Loads the Embeddables provider bundle and initialises the flow for the
 * section's <savvy> element. Separated from the wrapper so the overlay and
 * flow-detection paths can be tested without triggering an external fetch.
 *
 * Usage:
 *   window.BRXEmbeddablesLoader.load(sectionRoot, {
 *     onError: function() { /* show error copy *\/ }
 *   });
 */
(function () {
    function load(root, options) {
        var savvyEl = root ? root.querySelector('savvy') : null;
        if (!savvyEl) return;

        var onError = (options && options.onError) || function () {};

        var engineDomain = 'engine.embeddables.com';
        try {
            var qsDomain = new URL(window.location.href).searchParams.get('embeddables_engine_domain');
            if (qsDomain) engineDomain = qsDomain;
        } catch (e) {}

        var urlRoot = engineDomain.indexOf('http://localhost') === 0
            ? ''
            : engineDomain.indexOf('http') === 0
                ? engineDomain
                : 'https://' + engineDomain;

        function initEmbeddables() {
            var allUserData = {};
            try { allUserData = JSON.parse(localStorage.getItem('SavvyFormUserData') || '{}'); } catch (e) {}

            var attrs = {};
            for (var i = 0; i < savvyEl.attributes.length; i++) {
                var attr = savvyEl.attributes[i];
                attrs[attr.name] = attr.value;
            }

            var flowId = attrs.id;
            if (flowId && allUserData[flowId]) {
                var userData = {};
                var stored = allUserData[flowId] || {};
                for (var key in stored) {
                    if (!Object.prototype.hasOwnProperty.call(stored, key)) continue;
                    if (key === 'current_page_id' || key.indexOf('split_') === 0) {
                        userData[key] = stored[key];
                    }
                }
                attrs.userData = userData;
            }

            var url = urlRoot + '/init?load=' + encodeURIComponent(JSON.stringify({
                embeddablesToLoad: [attrs],
                originUrl: window.location.href
            }));

            fetch(url)
                .then(function (res) { return res.json(); })
                .then(function (response) {
                    if (!response || !response.init_js) throw new Error('Missing init payload');
                    eval('(' + response.init_js + ')(response.embeddables_data)');
                })
                .catch(function () { onError(); });
        }

        var existing = document.querySelector('script[data-embeddables-bundle="true"]');
        if (existing) {
            if (existing.getAttribute('data-loaded') === 'true') { initEmbeddables(); return; }
            existing.addEventListener('load', initEmbeddables, { once: true });
            return;
        }

        var script = document.createElement('script');
        script.src = urlRoot + '/bundle.js';
        script.async = true;
        script.setAttribute('data-embeddables-bundle', 'true');
        script.addEventListener('load', function () {
            script.setAttribute('data-loaded', 'true');
            initEmbeddables();
        }, { once: true });
        document.head.appendChild(script);
    }

    window.BRXEmbeddablesLoader = { load: load };
})();
